import type { AfterViewInit, DoCheck, IterableDiffer, OnInit, Type } from '@angular/core';
import {
  Component,
  inject,
  Input,
  IterableDiffers,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-rcr-exchange-sticky-footer',
  templateUrl: './rcr-exchange-footer.html',
  styleUrls: ['./rcr-exchange-footer.scss'],
})
export class RcrExchangeStickyFooterComponent implements AfterViewInit, OnInit, DoCheck {
  @Input() footerContent: Array<RcrStickyFooterConfig> = new Array<RcrStickyFooterConfig>();
  private footerContentInstances: Array<any> = new Array<any>();

  @ViewChild('target', { read: ViewContainerRef, static: true }) target: ViewContainerRef;
  private iterableDiffer: IterableDiffer<any>;
  private initialized: boolean;

  private _iterableDiffers = inject(IterableDiffers);

  ngOnInit() {
    this.iterableDiffer = this._iterableDiffers.find([]).create(null);
  }

  ngAfterViewInit() {
    /*this.loadComponent();*/
    this.initialized = true;
  }

  ngDoCheck() {
    const changes: any = this.iterableDiffer.diff(this.footerContent);
    if (changes) {
      this.clear();
      this.loadComponent();
    }
  }

  clear() {
    this.target.clear();
    this.footerContentInstances.splice(0, this.footerContentInstances.length - 1);
  }

  public getInstanceByIndex(_index: number): any {
    return this.footerContentInstances[_index];
  }

  private loadComponent(): void {
    for (const child of this.footerContent) {
      const contentInstance = this.target.createComponent(child.componentClass).instance;
      contentInstance.config = child;
      this.footerContentInstances.splice(child.componentIndex, 0, contentInstance);
    }
  }
}
export class RcrStickyFooterConfig {
  constructor(
    public componentClass: Type<{ config: RcrStickyFooterConfig }>,
    public componentIndex: number,
    public labelField: string,
    public value: any,
    public change: (value: any) => void,
    public click: (value: any) => void,
    public config: any,
  ) {}
}
